import React from 'react';
import {Modal} from '@snsw-gel/react';

interface CannotUnlinkModalProps {
    readonly onConfirm: () => void;
}

/**
 * A modal for when a user attempts to unlink their personal account but they have a claim which has a status that would block this.
 * This would not be used for tr2 linked accounts
 */
const CannotUnlinkModal: React.FC<CannotUnlinkModalProps> = (
    {
        onConfirm,
    }
) => {
    const title = 'Unable to make changes to linked Personal toll account';
    const description = 'You are not able to make changes to linked Personal toll accounts at this time as a claim is already being processed.';

    return <Modal
        title={title}
        description={description}
        buttons={[{text: 'OK', onClick: onConfirm}]}
    />;
};

export default CannotUnlinkModal;
